
import useAdBlockStore from "store/AdBlockStore";
import CreateBrandPanel from "./CreateBrand";
import SuggestionsPanel from "../SuggestionsPanel";
import CreateManufacturerOriginVariety from "./CreateManufacturerOriginVariety";

const ProductLeftPanel = () => {
    const leftPanelView = useAdBlockStore(state => state.leftPanelView);
    switch (leftPanelView) {
        case "variety":
        case "origin":
        case "manufacturer":
        case "model_number":
            return <CreateManufacturerOriginVariety />;
        case "brand":
            return <CreateBrandPanel />;
        default:
            return <SuggestionsPanel />;
    }
}

export default ProductLeftPanel;